import styled from '@emotion/styled';
import { Button, Grid, Paper, Stack } from '@mui/material'
import React, { useState } from 'react'
import { useCustomForm } from '../../../hooks/useCustomForm';
import { useOpenComponent } from '../../../hooks/useOpenComponent';
import { customStyles, justifyCenter } from '../../../styles';
import { CaptionText, MainButton, MainInput } from '../../helpers';
import CloseIcon from '@mui/icons-material/Close';
import { animations } from '../../../utils/animations';
import { useDispatch } from 'react-redux';
import { setQuantity } from '../../../slices/orderSlice';
import { useActiveElements } from '../../../hooks/useActiveElements';

const qt = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
  {
    id: 4,
  },
  {
    id: 'Otro',
  },
  ];
export const QTCilinders = () => {

  const Item = styled(Button)(({ theme }) => ({
    width: '100%',
    height: 100,
    borderRadius: 0,
    position: 'relative',
    overflow: 'hidden',
 }))
 const dispatch = useDispatch()
 const { fadeIn } = animations
 const {inputValues, handleOnChange} = useCustomForm({ customAmount: '' })
 const { customAmount } = inputValues
 const { isOpen, handleIsOpen, handleOpenControlled } = useOpenComponent()
 
 const { activeData, handleActive } = useActiveElements(qt)
 
 const handleQT = (qt) => {
  dispatch(setQuantity(qt))
  handleActive(qt)
}

const customQT = () => {
  dispatch(setQuantity(parseInt(customAmount)))
  handleActive(parseInt(customAmount))
  handleIsOpen()
 }
  return (
    <Grid container spacing={1} mt={10}>
      {
        activeData.map(item => (
          <Grid item xs={ item.id === 'Otro' ? 12 : 6 } >
            {
              item.id === 'Otro' && isOpen
              ? 
              <Stack spacing={3} className={fadeIn}>
                <MainInput name="customAmount" value={customAmount} onChange={handleOnChange} placeholder="Ingrese la cantidad" type="number" 
                // sx={  }}
                sx2={{fontSize: customStyles.fontSize.large}}
                inputProps={{textAlign: 'center'}}
                height={100}
                className={fadeIn}
                />
                <Stack direction="row" spacing={2} justifyContent="center">
                  <MainButton text="CANCELAR" variant="outlined" onClick={handleIsOpen}/>
                  <MainButton text="ACEPTAR" variant="contained" onClick={customQT}/>
                </Stack>
              </Stack>
              : <Paper className={fadeIn} sx={{transition: 'ease .2s',
              '&:active': {
                transform: 'scale(.97)'
              }}}>
                <Item onClick={ item.id === 'Otro' ? handleIsOpen : () => handleQT(item.id)} variant={ item.active ? 'contained' : '' }>
                  {item.id}
                  {/* {
                    item.id === 1 && 
                    <Paper sx={{ transform: 'skewY(20deg)', height: 80, position: 'absolute', top: -20, right: 0, display: 'flex', width: 55, justifyContent: 'center', alignItems: 'center', backgroundColor: customStyles.colors.red }}>
                      <CaptionText text="Más pedido" color={ customStyles.colors.backgroundColor } sx={{transform: 'skewY(-20deg)'}} bold/>
                    </Paper>
                  } */}
                </Item>
              </Paper>
            }
          </Grid>
        ))
      }

    </Grid>
  )
}
